import { gql } from "@apollo/client"

export const GET_ACTIVITY_LOG = gql`
  query getActivityLog($first: Int, $skip: Int) {
    myOrganization {
      id
      activityLog(first: $first, skip: $skip) {
        ... on GroupLogType {
          id
          dateTime
          action
          group {
            id
            name
            organizationGroup {
              name
            }
          }
          user {
            email
            firstName
            lastName
          }
          toTerminalSn
          toUser {
            email
            firstName
            lastName
          }
          read
        }
        ... on UserLogType {
          id
          dateTime
          userAction: action
          user {
            email
            firstName
            lastName
          }
          toUserEmail
          toOrganizationName
          toGroupName
          toUser {
            email
            firstName
            lastName
          }
          read
        }
      }
    }
  }
`
